import { ERC20Interface, useContractFunction } from "@usedapp/core";
import { Contract } from "ethers";

export function useTokenApproval(tokenAddress:any) {
    const tokenContract = new Contract(tokenAddress, ERC20Interface);
    const {state, send, events} = useContractFunction(tokenContract, 'approve', {transactionName: "approve ERC20 tranfer"});
    return {state, send, events};
}
